/**
 * Auth store — session / JWT token storage.
 *
 * Replaces the demo role-switch approach with real login session.
 * Token is stored persisted; role is derived from the login response user object.
 *
 * #186: MSW-backed; TODO(wire-be): swap token storage / validation against
 * real BE when #187 auth spec is finalised.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Roles returned by the auth endpoint. Maps 1:1 to AppRole in role.ts. */
export type AuthRole = "owner" | "manager" | "trainer";

export interface AuthUser {
  id: string;
  role: AuthRole;
  branchIds: string[];
}

interface AuthState {
  /** JWT bearer token. null = not logged in. */
  token: string | null;
  /** User object from login response / /me. null = not logged in. */
  user: AuthUser | null;
  /** Set after successful login. */
  setSession: (token: string, user: AuthUser) => void;
  /** Clear on logout or 401. */
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      clearSession: () => set({ token: null, user: null }),
    }),
    {
      name: "trainer-admin-auth",
    },
  ),
);
